import React from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { Box, Typography } from '@mui/material'
import { Ghost } from '../../../../../components/entry-decoration'
import { useSelector } from 'react-redux'

export const EmptyIndicatorMessage = ({ title, subtitle }) => (
  <Box display='flex' width='100%' p={8} flexDirection='column' alignItems='center' gap={2}>
    <Typography sx={{ fontSize: '32px', lineHeight: '40px', fontWeight: 600 }}>{title}</Typography>
    <Typography>
      {subtitle}
    </Typography>
    <Ghost />
  </Box>
)

const EmptyIndicator = () => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const selectedSection = useSelector(SkillBiteEditSlice.selectors.selectSelectedSection)

  if (!skillBite?.sessions?.length) {
    return (
      <EmptyIndicatorMessage
        title='No sessions yet'
        subtitle='Click on "Add Session" to continue the build'
      />
    )
  }

  if (selectedSession && !selectedSession?.sections?.length) {
    return (
      <EmptyIndicatorMessage
        title='No sections yet'
        subtitle='Click on "Add Section" to continue the build'
      />
    )
  }

  if (selectedSection && !selectedSection.pages.length) {
    return (
      <EmptyIndicatorMessage
        title='No pages yet'
        subtitle='Click on "Add Page" to continue the build'
      />
    )
  }

  return null
}

export default EmptyIndicator
